import _get from 'lodash.get';

import { Nullable } from '@types-internal';

export type ApplePayErrorType = 'initialization' | 'payment';

export function extractApplePayToken(state: unknown): Nullable<string> {
  const token = _get(state, 'data.paymentMethod.applePayToken', null);
  return typeof token === 'string' ? token : null;
}

export type ApplePayButtonColor = 'black' | 'white' | 'white-with-line';
